import { render, staticRenderFns } from "./TabInicio.vue?vue&type=template&id=0eec53d6&"
import script from "./TabInicio.vue?vue&type=script&lang=js&"
export * from "./TabInicio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports